// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"dfd3c8b1","450":"4a1aebc1"}[chunkId] + ".chunk.js";
};